// @owners { team: patients-team }
import { InputText } from '@alto/design-system';
import React from 'react';

type Props = {
  error?: string;
  onChange: (value: string) => void;
  value: string;
};

export const InsurancePcnInput = ({ error, onChange, value }: Props) => {
  return (
    <InputText
      autoCapitalize="characters"
      autoCorrect={false}
      error={error}
      id="pcn"
      keyboardType="default"
      label="Rx PCN"
      onChangeText={onChange}
      placeholder="0000000"
      value={value}
    />
  );
};
